import CIBCPopup from './CIBCPopup';

export default CIBCPopup;
